<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer/>
			<v-spacer/>
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				:label="$t('pages.orderFilter.search')"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			:search="lookingFor"
			:headers="headers"
			:items="projects"
			:loading="loading"
			class="elevation-1"
			:single-expand="false"
			:expanded.sync="expanded"
		>
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

			<template v-slot:item.actions="{ item }">
				<v-btn v-if="isManager ||isBranchClient || isClientManager" @click="addOrder(item)" class="success">
					{{ $t("pages.addOrder") }}
				</v-btn>
				<v-btn @click="closeProject(item)" class="red white--text">
					{{ $t("pages.closeProject") }}
				</v-btn>
				<v-btn @click="$emit('import',item)" class="primary">
					טעינת אקסל מדידות
				</v-btn>
				<c-btn tooltip-text="צפייה במדידות" target="_blank" icon color="success" :to="{name:'orders-page',query:{project_id:item.id}}">
					<v-icon>mdi-eye</v-icon>
				</c-btn>
				<edit-btn @click="onEdit(item)" />
				<remove-btn />
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {types} from "src/store/modules/Project.module";
	import FilterAble from "src/mixins/FilterAble";
	import CBtn from "src/scaffoldings/CBtn";

	export default {
		name: "projects-table",
		props: [],
		components: {CBtn},
		mixins: [new FilterAble(types)],
		data() {
			return {
				lookingFor: "",
				expanded: [],
				loading: false,
				showDialog: false
			};
		},
		created() {
			//hide rows from clients

		},
		computed: {
			IsClient() {
				return this.$store.getters.isClient;
			},
			isBranchClient() {
				return this.$store.getters.isBranchClient;
			}, isClientManager() {
				return this.$store.getters.isClientManager;
			}, isManager() {
				return this.$store.getters.isClientManager;
			},

			projects() {
				return this.$store.state.ProjectModule.projects;
			},
			headers() {
				let headers = [];
				if (!this.IsClient) {
					headers.push(
						{text: this.$t("pages.projectForm.branch"), value: "branch_name"},
						{text: this.$t("pages.orderFilter.clientName"), value: "client_name"}
					);
				}
				headers.push(
					{text: this.$t("pages.projectForm.projectName"), value: "name"},
					{text: this.$t("pages.projectForm.address"), value: "address"},
					{text: this.$t("pages.projectForm.city"), value: "city"},
					{text: this.$t("pages.projectForm.contractor"), value: "contractor"},
					{text: this.$t("pages.measurementTable.actions"), value: "actions", sortable: false}
				);
				return headers;
			}
		},
		methods: {
			addOrder(project) {
				this.$emit("add", project);
			},
			async closeProject(project) {
				let result = await this.$notfication.warning();
				if (result.value) {
					this.$store.dispatch(types.CLOSE, project);
				}
			},
			onEdit(project) {
				this.$emit("edit", project);
			}
		}
	};
</script>

<style>

</style>
